<template>
    <div>
        <div class="breadcrumb-box">
            <nav aria-label="breadcrumb">
                <ol class="breadcrumb">
                    <li
                        class="breadcrumb-item back"
                        style="font-family: poppins"
                    >
                        <a href="#" @click="$router.go(-1)">Back</a>
                    </li>
                    <li class="breadcrumb-item" style="font-family: poppins">
                        Restore Plant List
                    </li>
                </ol>
            </nav>
        </div>

        <div class="form-box mt-5">
            <div class="d-flex justify-content-between align-items-center">
                <h2
                    class="form-box__title"
                    style="font-family: proxima-nova, sans-serif"
                >
                    Restore Plant List
                </h2>
            </div>

            <table class="table tms-table">
                <thead>
                    <tr>
                        <th style="font-family: proxima-nova, sans-serif">
                            No.
                        </th>
                        <th style="font-family: proxima-nova, sans-serif">
                            Plant Name
                        </th>
                        <th style="font-family: proxima-nova, sans-serif">
                            Action
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(plant, index) in plants" :key="plant.id">
                        <td style="font-family: poppins">{{ index + 1 }}</td>
                        <td style="font-family: poppins">
                            {{ plant.plant_name }}
                        </td>
                        <td style="font-family: poppins">
                            <button
                                class="tms-button-circular"
                                @click="restorePlant(plant.id)"
                            >
                                <i class="fas fa-undo-alt"></i>
                            </button>
                            <!-- Button to trigger restore action -->
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>
import axios from "axios";
import Swal from "sweetalert2";

export default {
    metaInfo: {
        title: "Restore Plant List",
    },
    data() {
        return {
            plants: [],
        };
    },
    components: {},
    created() {
        this.fetchPlants();
    },
    watch: {},
    methods: {
        fetchPlants() {
            axios
                .get("/api/master/plant/restore?page=1&limit=10")
                .then((response) => {
                    console.log("Response data:", response.data);
                    this.plants = response.data.data;
                    console.log("Plants:", this.plants);
                })
                .catch((error) => {
                    console.error("Error fetching plants:", error);
                });
        },
        restorePlant(id) {
            Swal.fire({
                title: "Confirm Restore",
                text: "Are you sure you want to restore this plant?",
                icon: "warning",
                showCancelButton: true,
                confirmButtonText: "Yes",
                cancelButtonText: "Cancel",
            }).then((result) => {
                if (result.isConfirmed) {
                    axios
                        .put(`/api/master/plant/restore/${id}`)
                        .then((response) => {
                            console.log(
                                "Plant restored successfully:",
                                response.data
                            );
                            Swal.fire(
                                "Success!",
                                "Plant restored successfully!",
                                "success"
                            );
                            this.fetchPlants(); // Fetch updated plant list after restoration
                        })
                        .catch((error) => {
                            console.error("Error restoring plant:", error);
                            Swal.fire(
                                "Error!",
                                "Failed to restore plant",
                                "error"
                            );
                        });
                }
            });
        },
    },
};
</script>

<style scoped>
.tms-button-circular {
    width: 40px; /* Set the width and height to the same value for a perfect circle */
    height: 40px;
    border-radius: 50%; /* Makes the button circular */
    background-color: #d8e4ff; /* Sets the background color */
    padding: 10px 20px; /* Adjust padding to fit your content */
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    border: none;
    outline: none;
    box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1); /* Adjust shadow values as needed */
}

/* tms-table start */
.tms-table {
    width: 100%;
    border-collapse: collapse;
}

.tms-table th,
.tms-table td {
    padding: 8px;
    text-align: left;
    vertical-align: middle;
}

/* Styling for table headers */
.tms-table th {
    color: #bcbcbc;
    font-weight: normal;
    border-bottom: 0px solid #e4e7ea;
}

/* Styling for table data cells */
.tms-table td {
    font-weight: normal;
}

/* Remove top border from first row */
.tms-table tr:first-child td {
    border-top: none;
}
/* tms-table end */
</style>
